module.exports = __webpack_public_path__ + "static/media/rocket.8e0a4ef2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/socialIcons/rocket.png
// module id = 901
// module chunks = 0